import Debug from 'debug';
import { ExamStateMachineAbstractState, ExamStartOptions, ExamStateMachineCommonEvents } from './state'
import { ExamStateMachineData } from '../data'

const debug = Debug('exam-initial-state')

type Events = ExamStateMachineCommonEvents & {
  onStartRequested: (startOptions: ExamStartOptions) => void
}

export class ExamInitialState extends ExamStateMachineAbstractState<Events> {

  public readonly name = 'initial'

  constructor(private state: ExamStateMachineData) {
    super()
  }

  enter() {
    debug('enter')
    this.state.initialize()
  }

  exit() {
    debug('exit')
  }

  cancel() {
    debug('cancel')
    this.beginCancel()
    this.endCancel()
  }

  start(startOptions: ExamStartOptions) {
    this.triggerEvent(events => events.onStartRequested(startOptions))
  }
}
